import { faChevronUp } from '@fortawesome/sharp-solid-svg-icons';
import { FC, useCallback } from 'react';
import { twMerge } from 'tailwind-merge';

import { ButtonSize, ButtonVariant } from '@/components/button';
import DropDownButton from '@/components/dropDownButton';
import { useAuth } from '@/providers/auth-provider';
import { useModalContext } from '@/providers/ModalProvider';

type Props = {
  isMobile: boolean;
  groupOptions: any;
  disabled?: boolean;
};

export const ReportDropDownButton: FC<Props> = ({
  isMobile,
  groupOptions,
  disabled = false,
}) => {
  const { hasActiveSession } = useAuth();
  const { openAuthModal } = useModalContext();

  const handleOnDisabledClick = useCallback(() => {
    if (hasActiveSession) return;

    openAuthModal('signup');
  }, [hasActiveSession, openAuthModal]);

  return (
    <DropDownButton
      activeButtonClassName="bg-green-50 hover:bg-green-60 text-white"
      buttonClassName={`opacity-100 ${isMobile ? 'h-[44px] w-[44px]' : ''}`}
      buttonSize={ButtonSize.XS}
      buttonVariant={isMobile ? ButtonVariant.GHOST : ButtonVariant.SECONDARY}
      className={twMerge(
        'flex h-full w-full whitespace-nowrap text-white sm:h-[32px] sm:w-full sm:px-3',
        isMobile && 'h-[44px] w-[44px] items-center justify-center p-0'
      )}
      disabled={!hasActiveSession || disabled}
      groupOptions={groupOptions}
      icon={faChevronUp}
      iconClassName="p-0 h-min"
      overflowClassName="w-[160px]"
      overflowItemClassName="min-w-[100%]"
      onDisabledClick={handleOnDisabledClick}
    >
      {!isMobile && 'Create Report'}
    </DropDownButton>
  );
};
